import React, { useState, useEffect } from 'react'
import {
    Box, Stack, Typography,
    Tooltip, IconButton
} from '@mui/material';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { logSelector } from '../../../store/slices/logs';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import Topics from '../common/topics';
import LogDrawer from "../common/reviewComponents/logDrawer";
import ReactJson from 'react-json-view';

const Output = ({ isInitialTopics, outputView, companyId, outPutDnd, topics = [], output, topicKey, businessType, isGenerated,companyCompanyId }) => {
    const [openDrawer, setOpenDrawer] = useState(false);

    const { gptUsage } = useSelector(logSelector);
    const toggleDrawer = (isOpen) => {
        setOpenDrawer(isOpen);
    };
    const showLog = () => {
        return <Tooltip title={"Logs"}>
            <IconButton
                size="small"
                variant="contained"
                onClick={() => toggleDrawer(true)}
            >
                <TextSnippetIcon />
            </IconButton>
        </Tooltip>
    }
    const bindLastFetchedDate = () => {
        return <Stack direction={'row'} sx={{ justifyContent: 'space-between' }}>
            <Box className={'text-muted'} sx={{ display: 'flex', pb: 1 }}>
                Generated On:
                {topics[topicKey]?.lastModified &&
                    <Stack sx={{ pl: 1, justifyContent: 'space-between' }}>
                        {moment(topics[topicKey]?.lastModified).format('YYYY-MM-DD HH:mm:ss')}
                    </Stack>
                }
            </Box>
            <Box>{showLog()}</Box>
        </Stack >

    }
    return (
        <>
            {outputView === 3 &&
                <Topics companyCompanyId={companyCompanyId} isGenerated={isGenerated} businessType={businessType} isInitialTopics={isInitialTopics} height="calc(100vh - 308px)" topicKey={topicKey} lastModified={bindLastFetchedDate()} companyId={companyId} isEdit={true} outPutDnd={outPutDnd} title={'Output'} topics={topics} showData={true} ></Topics>
            }
            {outputView !== 3 &&
                <Box sx={{ width: '100%', overflowWrap: 'break-word' }}>
                    <Stack direction="row" sx={{ pb: 0.5 }} spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography variant="subtitle1">Output:</Typography>
                        {/* <Box> */}
                        {outPutDnd()}
                        {/* </Box> */}

                        {/* <Stack sx={{ width: '70%' }}>{' '}</Stack> */}
                    </Stack>
                    <hr style={{ marginTop: 0, }} />
                    {bindLastFetchedDate()}
                    <Box sx={{ height: "calc(100vh - 308px)", overflow: "auto" }} >

                        {typeof output === "string" && output}
                        {typeof output !== "string" &&
                            <ReactJson src={output} key={'text'} displayDataTypes={false} name={false} />
                        }
                    </Box>
                </Box>
            }
            <LogDrawer
                openDrawer={openDrawer}
                toggleDrawer={toggleDrawer}
                gptUsage={gptUsage}
            // selectedReviewText={selectedReviewText}
            // selectedReviewIds={selectedReviewIds}
            />
        </>
    )
}
export default Output;